class IoCarousel {

  constructor(settings) {
    this.settings = settings;
    this.el = document.querySelector(this.settings.el);
    this.btnPrev = document.querySelector(this.settings.el + ' .prev');
    this.btnNext = document.querySelector(this.settings.el + ' .next');
    this.images = document.querySelectorAll(this.settings.el + ' .io-items-container > *');
    this.activeImage = 0;
    this.animateQueque = true;
    this.autoplay = this.settings.autoplay || false;
    this.autoplayInterval = this.settings.autoplayInterval || 5000;
    this.pauseOnHover = this.settings.pauseOnHover || false;
    this.isPaused = false;
    this.prefixClass = this.settings.prefixClass || '';

    for(let i = 1; i < this.images.length; i++){this.images[i].style.display = 'none'};
    if(this.btnPrev){this.btnPrev.onclick = () => { this.goPrev() };}
    if(this.btnNext){this.btnNext.onclick = () => { this.goNext() };}
    if(this.autoplay){this.runAutoplay()};
    if(this.pauseOnHover){
      this.el.onmouseover = () => {this.isPaused = !this.isPaused}
      this.el.onmouseout = () => {this.isPaused = !this.isPaused}
    }
  }

  goNext() {

    if (this.animateQueque) {
      this.animateHide(this.images[this.activeImage], this, 'next', () => {
        this.activeImage++;
        if (this.activeImage >= this.images.length) {this.activeImage = 0;};
      });
    }
    this.animateQueque  = false;
    
  }

  goPrev() {

    if (this.animateQueque) {
      this.animateHide(this.images[this.activeImage], this, 'prev', () => {
        this.activeImage--;
        if (this.activeImage < 0) {this.activeImage = this.images.length - 1;};
      });
    }
    this.animateQueque  = false;

  }

  animateHide(image, obj, nextOrPrev, callback) {
    
    var handler = function() {
      image.style.display = 'none';
      image.classList.remove(obj.prefixClass + nextOrPrev + '-leave-active');
      callback();
      image.removeEventListener('transitionend', handler);
      obj.animateShow(obj.images[obj.activeImage], obj, nextOrPrev); 
    }

    image.classList.add(obj.prefixClass + nextOrPrev + '-leave-active');
    image.addEventListener('transitionend', handler);

  }

  animateShow(image, obj, nextOrPrev) {
    
    var handler = function() {
      image.classList.remove(obj.prefixClass + nextOrPrev + '-enter-active');
      obj.animateQueque  = true;
      image.removeEventListener('transitionend', handler);
    }

    image.style.display = 'block';
    image.classList.add(obj.prefixClass + nextOrPrev + '-enter');

    this.raf(function() {
      image.classList.add(obj.prefixClass + nextOrPrev + '-enter-active');
      image.classList.remove(obj.prefixClass + nextOrPrev + '-enter');
    }); 
    image.addEventListener('transitionend', handler);

  }

  runAutoplay() {
    setInterval( () => {
      if(!this.isPaused) {
        this.goNext()
      }
    }, this.autoplayInterval)
  }

  raf(fn) {
    window.requestAnimationFrame(function() {
      window.requestAnimationFrame(function() {
        fn();
      })
    })
  }

}